export const V1_REQUEST_USER = 'V1_REQUEST_USER'

export default () => {
  return {
    type: V1_REQUEST_USER,
  }
}
